import React from "react";
import {
  addOns,
  PlanInfoViewOnPricingPage as PlanInfo,
} from "../../utils/backLinkPlanInfo";
import PlanCard from "./PlanCard";
import "./pricing.css";
import { useEffect } from "react";
import { auth2 } from "../../../firebase";
import { useState } from "react";
import { useSelector } from "react-redux";
import AddOnCard from "./AddOnCard";
import TipLoader from "../../utils/TipLoader/TipLoader";
import { createStripeCustomer, manageSubscription } from "./stripeFunctions";

const Pricing = () => {
  const plans = Object.values(PlanInfo);
  const [currentPlan, setCurrentPlan] = useState(1);
  const [queryPlan, setQueryPlan] = useState(null);
  const [hasTrialTaken, setHasTrialTaken] = useState(false);
  const [isTrialPlan, setIsTrialPlan] = useState(false);
  const userAddOns = useSelector(
    (state) => state.userData.currentWorkSpaceAddOns,
  );
  const [loading, setLoading] = useState(false);

  // console.log({userAddOns})

  useEffect(() => {
    createStripeCustomer();
    const plan = auth2.currentUser.reloadUserInfo.customAttributes;
    console.log({ custom: plan });
    if (plan) {
      const parse = JSON?.parse(plan);
      console.log({ customClaims: plan, parse });
      let actualPlan = parse?.plan;
      if (actualPlan) {
        setCurrentPlan(+actualPlan.split("plan")[1]);
      }
      if (parse?.trialPlan) {
        setCurrentPlan(+parse.trialPlan.split("plan")[1]);
        setIsTrialPlan(true);
      }
      if (parse?.trial === "yes") {
        setHasTrialTaken(true);
      }
    } else {
      setCurrentPlan(1);
    }

    // get the plan from the query params
    const urlParams = new URLSearchParams(window.location.search);
    const qPlan = urlParams.get("plan");
    if (qPlan) {
      setQueryPlan(+qPlan);
    }
  }, []);

  // console.log({ plans, currentPlan, queryPlan, loading })
  return (
    <>
      {loading && <TipLoader />}
      <div className="planContainer">
        {plans.map((plan, index) => (
          <PlanCard
            key={plan.name}
            planNo={plan.equivalentPlan}
            plan={plan}
            currentPlan={currentPlan}
            hasTrialTaken={hasTrialTaken}
            isTrialPlan={isTrialPlan}
            queryPlan={queryPlan}
            setLoading={setLoading}
          />
        ))}
      </div>
      <h2>Add ons</h2>

      <div className="planContainer">
        {addOns.map((addOn, index) => (
          <AddOnCard
            key={index}
            addOn={addOn}
            currentAddOns={userAddOns}
            setLoading={setLoading}
          />
        ))}
      </div>
      <div>
        <button
          className="manageSubscription"
          onClick={() => manageSubscription(setLoading)}
        >
          Manage Subscription
        </button>
      </div>
    </>
  );
};

export default Pricing;
